import { t } from "@lingui/macro";
import * as React from "react";
import { Path, Circle } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CartIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="none"
    color="#001A19"
    testID="cart-icon"
    title={t`Cart`}
    {...props}
  >
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.595 7.676 15 8.432v3.784H1l.378-5.297h1.136m9.08.757H5.542v-.757h-.757m6.81.757L10.46 2M4.784 6.919h-2.27m2.27 0V3.892m0-1.892h5.676M4.784 2h-.757m.757 0v1.892M10.46 2h1.135M2.514 6.919V3.892h2.27"
      fill="none"
    />
    <Circle
      cx={4.027}
      cy={12.216}
      r={1.514}
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <Circle
      cx={11.595}
      cy={12.216}
      r={1.514}
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </Icon>
);
